import React from 'react';
import FullCalendar from '@fullcalendar/react'; // For calendar
import dayGridPlugin from '@fullcalendar/daygrid'; // Month view plugin
import interactionPlugin from '@fullcalendar/interaction'; // For clicking dates
import '../styles/NotesHistoryWidget.css'; // external CSS file

const NotesHistoryWidget = ({ currentDate, notes, fetchNotesByDate, resetToPresent }) => {
  // Safeguard against missing or undefined notes
  const filteredNotes = notes?.filter((note) => note.date === currentDate) || [];

  return (
    <div className="notes-history-container">
      {/* Calendar Section */}
      <div className="notes-history-calendar">
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: 'prev,next',
            center: 'title',
            right: 'today',
          }} // Added navigation for months
          dateClick={(info) => fetchNotesByDate(info.dateStr)} // Pass selected date
          initialDate={currentDate} // Show currentDate by default
        />
      </div>

      {/* Notes Section */}
      <div className="notes-history-notes-section">
        <h4>Notes for {new Date(currentDate).toLocaleDateString()}</h4>
        {filteredNotes.length > 0 ? (
          filteredNotes.map((note) => (
            <div key={note.id} className="notes-history-note">
              <p>
                <strong>{note.title}</strong>
              </p>
              <p>{note.text}</p>
            </div>
          ))
        ) : (
          <p>No notes available for this date.</p>
        )}
        {/* Reset to Present Button */}
        <button className="notes-history-present-button" onClick={resetToPresent}>
          Go to Present
        </button>
      </div>
    </div>
  );
};

export default NotesHistoryWidget;
